module.exports = __webpack_public_path__ + "img/get_response_logo.170c9852.png";